import { render, staticRenderFns } from "./CreditNoteDisplay.vue?vue&type=template&id=028ebbb8"
import script from "./CreditNoteDisplay.vue?vue&type=script&lang=js"
export * from "./CreditNoteDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports